<template>
    <section>
        <div class="container container--fluid">
            <v-card>
                <v-card-title class="headline">
                    {{$t('inbox_faxes_list')}}
                    <v-spacer></v-spacer>
                    <v-btn
                            icon
                            small
                            @click="fetch()"
                    >
                        <v-icon right dark>mdi-reload</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-subtitle>{{$t('inbox_fax_list_subtitle')}}</v-card-subtitle>
                <v-divider></v-divider>
                <v-data-table
                        class="text-capitalize"
                        :headers="headers"
                        :items="items"
                        :loading="loading"
                        :options.sync="options"
                        :server-items-length="total"
                        :page="options.page"
                        :items-per-page="options.itemsPerPage"
                        :footer-props="footerProps"
                >
                    <template v-slot:top>
                        <v-text-field
                                append-icon="mdi-magnify"
                                v-model="search"
                                label="جستجو"
                                class="mx-4"
                        ></v-text-field>
                    </template>
                    <template #item.from="{item}">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <router-link
                                        :to="{name : 'Inbox', query : { filters : [{column_name : 'from', operand : 'IsEqualTo', value : item.from}]}}"
                                        color="red"
                                        text-color="white"
                                        v-bind="attrs"
                                        v-on="on"
                                >{{item.from}}</router-link>
                            </template>
                            <span>{{$t('fax_filtered_by_from')}}</span>
                        </v-tooltip>


                        <CopyToClipboard :text="item.from"/>
                    </template>
                    <template #item.status="{item}">
                        <v-chip
                                small
                                class="ma-2"
                                :color="getStatusColor(item)"
                                text-color="white"
                        >
                            {{$t("fax_status")[item.status]}}
                        </v-chip>

                    </template>
                    <template #item.to="{item}">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <div
                                        v-bind="attrs"
                                        v-on="on"
                                >
                                    <v-chip
                                            v-if="item.to_vertical_service_code"
                                            color="info"
                                            small
                                            class="ma-2"
                                            text-color="white"
                                    >
                                        {{$t('to_vertical_service_code' , {
                                        to_vertical_service_code : item.to_vertical_service_code
                                        })}}
                                    </v-chip>
                                    <router-link
                                            :to="{name : 'Inbox', query : { filters : [{column_name : 'to', operand : 'IsEqualTo', value : item.to},{column_name : 'to_vertical_service_code', operand : 'IsEqualTo', value : item.to_vertical_service_code}]}}"
                                            text-color="white"
                                    >
                                        <span>{{item.to}}</span>
                                    </router-link>

                                    <CopyToClipboard :text="item.to"/>
                                </div>
                            </template>
                            <span>{{$t('fax_filtered_by_to')}}</span>
                        </v-tooltip>


                    </template>

                    <template #item.attempts="{item}">
                        {{ $t('messages.attempts',{ attempts : item.attempts, tries : item.tries}) }}
                    </template>
                    <template #item.created_at="{item}">
                        {{ getJalaliDate(item.created_at * 1000) }}
                    </template>
                    <template #item.completed_at="{item}">
                            <span v-if="item.completed_at">
                                {{ getJalaliDate(item.completed_at * 1000) }}
                            </span>
                        <v-chip
                                v-else
                                small
                                class="ma-2"
                                text-color="white"
                        >
                            {{$t('undefined')}}
                        </v-chip>
                    </template>
                    <template #item.fax_channel_id="{item}">
                        <transition name="fade" mode="out-in">
                            <v-chip
                                    v-if="!item.fax_channel_id"
                                    color="error"
                                    x-small
                            > -- </v-chip>

                            <v-skeleton-loader
                                    v-else-if="fetchingFaxChannels"
                                    type="text"
                                    class="mt-2"
                            ></v-skeleton-loader>

                            <div v-else>
                                <v-tooltip top color="info" v-if="faxChannels[item.fax_channel_id].description">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                                v-bind="attrs" v-on="on"
                                                color="info"
                                        >mdi-information-outline</v-icon>
                                    </template>
                                    <span>{{faxChannels[item.fax_channel_id].description}}</span>
                                </v-tooltip>
                                {{ faxChannels[item.fax_channel_id].name }}
                            </div>
                        </transition>
                    </template>
                    <template #item.actions="{item}">
                        <v-tooltip top v-if="item.file_id">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon small :loading="downloadFileLoading.indexOf(item.id) > -1" @click="downloadFile(item)" v-bind="attrs" v-on="on">
                                    <v-icon>mdi-cloud-download-outline</v-icon>
                                </v-btn>
                            </template>
                            <span>{{$t('download_fax_file')}}</span>
                        </v-tooltip>
                        <v-tooltip top v-else>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                        icon
                                        small
                                        :loading="retryingFaxes.indexOf(item.id) > -1"
                                        @click="retryIncoming(item)"
                                        :disabled="false && item.status !== 'failed_receive'"
                                        v-bind="attrs"
                                        v-on="on">
                                    <v-icon>mdi-reload</v-icon>
                                </v-btn>
                            </template>
                            <span>{{$t('retryingIncoming')}}</span>
                        </v-tooltip>
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <router-link
                                        :to="{ name: 'Logs', query: { filters: [{ value: item.id, operand: 'IsEqualTo', column_name : 'fax_id' }], orders: [{ 'column_name' : 'id', 'value' : 'desc' }] } }"
                                        class="no-decoration"
                                >
                                    <v-icon
                                            v-bind="attrs"
                                            v-on="on"
                                    >mdi-math-log</v-icon>
                                </router-link>

                            </template>
                            <span>{{$t('logs')}}</span>
                        </v-tooltip>

                        <v-btn small text color="info" @click="showFax = item">
                            <v-icon left>
                                mdi-eye
                            </v-icon>
                            نمایش جزییات
                        </v-btn>
                    </template>
                </v-data-table>
            </v-card>
        </div>
        <FaxDetails
                v-if="showFax"
                :fax="showFax"
                @close="showFax = null"
        ></FaxDetails>
    </section>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';

    import RequestList from "../services/RequestList";
    import Service from "../services/FaxesService";
    import StorageService from "../services/StorageService";
    import CopyToClipboard from '@/components/CopyToClipboard'
    import FaxDetails from '../components/FaxDetails'
    import CRUDMixin from '../mixins/CRUDMixin'


    export default {
        mixins : [CRUDMixin],

        components : {
            CopyToClipboard,
            FaxDetails
        },
        mounted() {
            if(Object.keys(this.faxChannels).length <= 0){
                this.syncFaxChannels();
            }
        },
        computed: {
            ...mapGetters({
                faxChannels: 'faxChannels/keyedById',
                fetchingFaxChannels: 'faxChannels/fetching',
            })
        },
        watch: {
            dialog (val) {
                !val && this.close()
            }
        },
        data() {
            return {
                showFax : null,
                search : null,
                loading : false,
                downloadFileLoading : [],
                retryingFaxes : [],
                retrySendItems : [],
                headers : [
                    {
                        text: this.$t('from'),
                        value: 'from',
                    },
                    {
                        text: this.$t('to'),
                        value: 'to',
                    },
                    {
                        text: this.$t('created_at'),
                        value: 'created_at',
                    },
                    {
                        text: this.$t('fax_channel'),
                        value: 'fax_channel_id',
                    },
                    {
                        text: this.$t('status'),
                        value: 'status',
                    },
                    {
                        text: this.$t('action'),
                        value: 'actions',
                    }
                ],
                items : [],
            }
        },
        methods: {
            ...mapActions({
                syncFaxChannels: 'faxChannels/sync'
            }),

            async fetch() {
                this.loading = true;

                let page = this.$route.query.page || 1;
                let count = this.$route.query.count || this.options.itemsPerPage;

                let requestList = new RequestList();

                requestList.setFilters(this.$route.query.filters || []);
                requestList.addOrder('id','desc');
                requestList.setPage(page, count);
                requestList.addFilter('type', 'IsEqualTo', 'incoming');

                try {
                    let {data} = await Service.list(requestList);
                    this.items = data.value.faxes;
                    this.total = data.value.total;
                } finally {
                    this.loading = false;
                }
            },
            async retryIncoming(fax) {
                this.retryingFaxes.push(fax.id);

                try {
                    await Service.retryIncoming(fax);
                    this.fetch();
                } finally {
                    this.retryingFaxes.splice(this.retryingFaxes.indexOf(fax.id), 1);
                }

            },

            async downloadFile(fax){
                this.downloadFileLoading.push(fax.id);

                let request = new RequestList();
                request.addFilter('id','IsEqualTo', fax.file_id);

                let {data} = await StorageService.list(request);

                this.downloadFileLoading.splice(this.downloadFileLoading.indexOf(fax.id), 1);

                let link = document.createElement("a");
                // If you don't know the name or want to use
                // the webserver default set name = ''
                link.href = data.value.files.pop().url;
                link.target = '_blank';
                link.style.display = 'none';
                document.body.appendChild(link);
                link.click();
                link.remove();

            },
            getStatusColor(fax){
                let color = null;
                switch (fax.status){
                    case 'incoming_queue' :
                        color = 'warning';
                        break;
                    case 'receiving' :
                        color = null;
                        break;
                    case 'failed_receive' :
                        color = 'error';
                        break;
                    case 'canceled' :
                        color = 'secondary';
                        break;
                    case 'received' :
                        color = 'success';
                        break;
                }
                return color;
            },

        }
    }
</script>